package dev.lingvo.shared.ops

import kotlinx.serialization.Serializable

@Serializable
enum class OpsLogSource { BOTH, INTERNAL_ONLY, UNCLAIMED }

@Serializable
enum class OpsLogScope { WORKSPACE, PLATFORM, ALL }

@Serializable
data class OpsLogFactDto(val label: String, val value: String)

@Serializable
data class OpsLogRowDto(
    val id: String,
    val at: String,
    val source: OpsLogSource,
    val operator: String,
    val operatorUserId: String?,
    val action: String,
    val sentence: String,
    val reason: String?,
    val note: String?,
    val orgId: String?,
    val orgLabel: String?,
    val subjectUserId: String?,
    val subjectLabel: String?,
    val targetKind: String?,
    val targetId: String?,
    val facts: List<OpsLogFactDto>,
    val undeclaredFacts: Int,
)

@Serializable
data class OpsReadDayRowDto(
    val day: String,
    val operator: String,
    val operatorUserId: String,
    val reads: Int,
    val workspaces: Int,
    val burstThreshold: Int,
    val overThreshold: Boolean,
)
